import { z } from 'zod';
import { MAX_FILE_SIZE_BYTES, MEGA_BYTE_TO_BYTE, MIN_FILE_SIZE_BYTES, VALID_FILE_EXTENSIONS } from '../constants';
import { isValidFileExtension, requiredApplicationIdString, truncateFileName } from '../helper';
import { ApplicationDocumentType, ApplicationEntityType, RequestedDocumentType } from '../types';

export const createDocumentSchema = z.object({
  applicationId: requiredApplicationIdString(),
  documentRequestId: z.number().int().positive().optional(),
  entityType: z.nativeEnum(ApplicationEntityType).optional(),
  fileSize: z
    .number()
    .min(MIN_FILE_SIZE_BYTES, `File size must be greater than ${MIN_FILE_SIZE_BYTES / MIN_FILE_SIZE_BYTES} KB`)
    .max(MAX_FILE_SIZE_BYTES, `File size must be less than ${MAX_FILE_SIZE_BYTES / MEGA_BYTE_TO_BYTE} MB`),
  filename: z
    .string()
    .trim()
    .min(5)
    .refine(file => isValidFileExtension(file, VALID_FILE_EXTENSIONS), 'Invalid file extension')
    .transform(file => truncateFileName(file)),
  declaredDocumentType: z.nativeEnum(RequestedDocumentType).optional(),
  type: z.nativeEnum(ApplicationDocumentType).optional(),
});
